module.exports = __webpack_public_path__ + "img/c13110e90e044a814542ac967c09ede5.png";